import axios from "axios";
import type { ReportUploadTarget } from "./_models/ReportUpload";

const s3Client = axios.create();

/**
 * PUTs a file straight to S3 at a presigned URL (from createReportUpload), reporting progress.
 * Uses a bare axios instance: S3 rejects a presigned request that also carries our Authorization header.
 */
export const uploadReportFile = async (
  target: ReportUploadTarget,
  file: File,
  onProgress: (fraction: number) => void,
): Promise<void> => {
  await s3Client.put(target.uploadUrl, file, {
    headers: { "Content-Type": target.contentType },
    onUploadProgress: (event) => {
      if (event.total) onProgress(event.loaded / event.total);
    },
  });
};
